import styled from 'styled-components';

const TopbarNavigationWrapper = styled.div`
  nav {
    box-shadow: none !important;
    border-bottom: 1px solid #dfe2e7;
    line-height: 1.5;
  }
`;

export { TopbarNavigationWrapper };
